export const calculateBoundsCenter = bounds => ({
  lat: (bounds.north + bounds.south) / 2,
  lng: (bounds.east + bounds.west) / 2,
});

export const initialState = {
  mapLayers: {
    boundingBox: null,
    polygon: null,
  },
  map: null,
};
